import { maxLength, required } from '@angular/forms/signals';
import type { FieldTree } from '@angular/forms/signals';
import { form } from '@angular/forms/signals';
import type { WritableSignal } from '@angular/core';
import type {
  CreateOrganizationInput,
  OrganizationDto,
  UpdateOrganizationInput,
} from '../../shared';

export interface OrganizationFormModel {
  id: string | undefined;
  name: string;
}

export function createOrganizationFieldTree(
  model: WritableSignal<OrganizationFormModel>,
): FieldTree<OrganizationFormModel> {
  return form(model, (schema) => {
    required(schema.name, { message: 'settings.organizations.form.validation.nameRequired' });
    maxLength(schema.name, 255, { message: 'settings.organizations.form.validation.nameMaxLength' });
  });
}

export class OrganizationFormFactory {
  static initialModel(initial?: Partial<OrganizationDto>): OrganizationFormModel {
    return {
      id: initial?.id,
      name: initial?.name ?? '',
    };
  }

  static toCreatePayload(formValue: OrganizationFormModel): CreateOrganizationInput {
    return {
      name: formValue.name.trim(),
    };
  }

  static toUpdatePayload(formValue: OrganizationFormModel): UpdateOrganizationInput {
    if (!formValue.id) {
      throw new Error('ID is required for update operations');
    }
    return {
      id: formValue.id,
      name: formValue.name.trim(),
    };
  }
}
